import { useState } from "react";
import { Crown, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { usePaymentPolling } from "../hooks/usePaymentPolling";
import {
  PLAN_CARDS,
  PlanCard,
  PaymentStatusBanner,
  PremiumActiveBanner,
} from "../components/PremiumParts";

const PERKS = [
  "Unlimited likes every day",
  "See everyone who's interested in you",
  "Filter by relationship dynamic",
  "Support a platform built for marriage",
];

export default function PremiumPage() {
  const [loadingPlan, setLoadingPlan] = useState(null);
  const { user } = useAuth();
  const paymentState = usePaymentPolling();

  const checkout = async (planId) => {
    setLoadingPlan(planId);
    try {
      const { data } = await api.post("/payments/checkout", {
        plan_id: planId,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoadingPlan(null);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16" data-testid="premium-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C19A6B] flex items-center gap-2">
        <Crown className="w-4 h-4" strokeWidth={1.5} /> Evervow Premium
      </p>
      <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-4 max-w-2xl">
        Serious about marriage? Go all in.
      </h1>

      <PaymentStatusBanner state={paymentState} />
      {user?.is_premium && paymentState !== "paid" && <PremiumActiveBanner user={user} />}

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <h2 className="font-serif text-2xl">Everything Premium includes</h2>
          <ul className="mt-8 space-y-4">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-[#5C5C5C]">
                <Check className="w-5 h-5 text-[#4A5D4E] mt-0.5" strokeWidth={1.5} />
                {p}
              </li>
            ))}
          </ul>
          <p className="mt-10 text-sm text-[#8A8A8A] max-w-sm">
            Straight payments, no auto-renewal surprises. Your membership simply extends each time
            you purchase.
          </p>
        </div>
        <div className="space-y-6">
          {PLAN_CARDS.map((plan, i) => (
            <PlanCard key={plan.id} plan={plan} index={i} onCheckout={checkout} loadingPlan={loadingPlan} />
          ))}
        </div>
      </div>
    </div>
  );
}
